import React from "react";
import { Link } from "react-router-dom";
import "./NeedAbout.css";

export default function NeedAbout() {
  return (
    <section className="needabout-section">
      <div className="needabout-overlay">
        <div className="needabout-content">
          <h2 className="needabout-title"> 
            Need Reliable Printing Solutions?
          </h2>
          <p className="needabout-subtitle">
            We’re here 24×7 to support your business from supplies to after-sales service.
          </p>
           <p className="needabout-subtitle contact-info">
  Phone: 08169405098 <span className="mobile-break"></span> Email: info@recla.com.ng
</p>

      
          <Link to="/contact" className="needabout-btn">
            Connect With Us <span className="arrow">→</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
